var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17887 17.1387C7.52887 17.1387 7.64554 16.8887 7.41221 16.272L5.51221 10.0053L17.3122 2.63867L18.6955 3.00534L17.5455 6.13867L8.17887 17.1387Z",
    fill: "#C8DAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1792 17.1393C8.6792 17.1393 8.89587 16.906 9.1792 16.6393C9.61253 16.2227 15.1792 10.806 15.1792 10.806L11.7625 9.97266L8.59587 11.9727L8.1792 16.9727V17.1393Z",
    fill: "#A9C9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51227 12.0387L16.5789 17.9887C17.4956 18.4887 18.1623 18.2387 18.3956 17.1387L21.6789 1.67208C22.0123 0.322078 21.1623 -0.277921 20.2789 0.122079L1.01227 7.55541C-0.3044 8.08875 -0.287734 8.82208 0.778933 9.13875L5.72893 10.6887L17.1789 3.47208C17.7123 3.13875 18.2123 3.32208 17.8123 3.68875L8.51227 12.0387Z",
    fill: "url(#paint0_linear_740_4516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_4516",
    x1: 13.3441,
    y1: 8.59791,
    x2: 17.5108,
    y2: 15.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d496e2c3.svg";
export { ForwardRef as ReactComponent };